import React, { useState, useEffect, useRef, useCallback } from "react";
import Services from "../../utils/services";
import ApiServices from "../../utils/apiServices";
import { useHistory, useLocation } from "react-router";
import "./GenAIRecommendedHome.css";
import { imsLoader, popCancelBttn, filterIconWhite, collapseFilterWhite, expandFilterWhite, JJ_IM_Logo, JJ_Icon_Filter, JJ_Icon_Share } from "../../assets";
import HeaderSearch from "../../components/header/HeaderSearch";
import SearchFilter from "../FilterComponent/SearchFilter";
import Footer from "../../components/footer/Footer";
import WNFYSection from "../../components/WNFY/WNFYSection";
import ContentShortcut from "../../components/ContentShortcuts/ContentShortcutLayout";
import NavigationMenu from "../../components/Navigation/NavigationMenu";
import WOAVSection from "../../components/WOAV/WOAVSection";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import SearchAskQuestionIndex from "../../components/GenAIRecommendedHome/SearchAskQuestionIndex";
import GenAINavigationMenu from "../../components/Navigation/GenAINavigationMenu";
import processFilters from '../GenAIFilterComponent/ProcessFilter'
import queryString from 'query-string';
import GenerateArrayStrings from "../../components/GenerateArrayStrings";
import { UtilityServices, ContentShortcutsInfo } from '../../utils/utilityServices'
import moment from 'moment';
import GenAISearchFilter from "../GenAIFilterComponent/GenAISearchFilter";
import ContentShortcutLayoutGenAIRecomended from "../../components/ContentShortCutGenAI/ContentShortcutLayoutGenAIRecomended";
import { Popover } from 'react-tiny-popover';
import GenAIHomeHeader from "../../components/header/GenAIHomeHeader";
import GenAIHomeFooter from "../../components/footer/GenAIHomeFooter";
import ContentShortcutGenAI from "../../components/ContentShortCutGenAI/ContentShortcut";
import { v4 as uuidv4 } from 'uuid';
import GenAIHomeFilterDisplay from "../../components/GenAIFilterDisplay/GenAIHomeFilterDisplay";
import HomeCSShortcut from "../../components/GenAIRecommendedHome/HomeCSShortcut";
import HomeBookmarkShortcut from "../../components/GenAIRecommendedHome/HomeBookmarkShortcut";
import FilterService from "../../services/FilterService";
import { Authentication } from "../../utils/authenticationUtilityServices";
import ResponsiveFilterComponent from "../ResponsiveFilterComponent/ResponsiveFilterComponent";
import RecentlyViewedSection from '../../components/History/RecentlyViewedSection'
import QueryHistorySection from '../../components/History/QueryHistorySection'
import AuthoringDisclaimer from '../../components/Authoring/AuthoringDisclaimer'
import trackingService from "../../services/trackingService";
import axios from "axios";
import { LocationOrigin, LimitedUser, MISEHCP, AllContent, isShowAIOverview, getFormattedAccessGroup } from "../../utils/utilityServices";
import {
    isDesktop,
} from "react-device-detect";
export default function GenAIRecommendedHome(props) {
    const useridRef = useRef(null);
    const wwidRef = useRef(null);
    const userExistsRef = useRef(null);
    const [username, setUsername] = useState("");
    const [userExists, setUserExists] = useState(false);
    const [funcLoaded, setFuncLoaded] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [customWidth, setCustomWidth] = useState(window.innerWidth);
    const [customHeight, setCustomHeight] = useState(window.innerHeight);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [allFilters, setAllFilters] = useState({});
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [showContentShortcuts, setShowContentShortcuts] = useState(false);
    const [filters, setFilters] = useState({});
    const [initials, setInitials] = useState("");
    const [recentlyUsedFilters, setRecentlyUsedFilters] = useState([]);
    const [fromRecentlyAddedUpdated, setFromRecentlyAddedUpdated] = useState(0);
    const [toRecentlyAddedUpdated, setToRecentlyAddedUpdated] = useState(6);
    const [selectedParentFilterArr, setSelectedParentFilterArr] = useState([]);
    const [savedShortcutsScrollTimeStamp, setSavedShortcutsScrollTimeStamp] = useState(0);
    // const [dropdownValue, setDropdownValue] = useState("All Fields");
    // const [fieldedValue, setFieldedValue] = useState("");

    const [showAnDCSModal, setShowAnDCSModal] = useState(false);
    const [showSRnCSModal, setShowSRnCSModal] = useState(false);
    const [showEnTCSModal, setShowEnTCSModal] = useState(false);
    const [showKMLCSModal, setShowKMLCSModal] = useState(false);
    const [showKCLCSModal, setShowKCLCSModal] = useState(false);
    const [showLDCSModal, setShowLDCSModal] = useState(false);
    const [showSCDCSModal, setShowSCDCSModal] = useState(false);
    const [showCRPCSModal, setShowCRPCSModal] = useState(false);
    const [showTAnDCSModal, setShowTAnDCSModal] = useState(false);
    const [showEPCSModal, setShowEPCSModal] = useState(false);
    const [showMIRCSModal, setShowMIRCSModal] = useState(false);
    const [SavedShortcuts, setSavedShortcuts] = useState([]);
    const [bookmarkShortcuts, setBookmarkShortcuts] = useState([]);
    const [documentItems, setDocumentItems] = useState([]);
    const [showMCECSModal, setShowMCECSModal] = useState(false);
    const [showGMAFCSModal, setShowGMAFCSModal] = useState(false);
    const [isPopupModalOpen, setIsPopupModalOpen] = useState(false);
    const [documentCount, setDocumentCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(null);
    const [collapseFilter, setCollapseFilter] = useState(false);
    const [showDisclaimerPopup, setShowDisclaimerPopup] = useState(false);
    let userid = '';
    const history = useHistory();
    const location = useLocation();
    // componentWillMount equivalent logic (runs once)
    useEffect(() => {
        if (
            location &&
            location.search &&
            (location.search.includes("code=") || location.search.includes("state="))
        ) {
            history.replace("/");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // run once on mount

    useEffect(async () => {
        try {
            document.title = 'iMedical Search';
            window.scrollTo(0, 0);

            userid = JSON.parse(localStorage.getItem('username'));
            let wwid = JSON.parse(localStorage.getItem('wwid'));
            let userExists = localStorage.getItem('userExists');
            useridRef.current = JSON.parse(localStorage.getItem("username"));
            wwidRef.current = JSON.parse(localStorage.getItem("wwid"));
            userExistsRef.current = localStorage.getItem("userExists");
            let service = new Services();
            let apiService = new ApiServices();
            service.logService(`Gen Ai Home page successfully mounted for ${userid.toLowerCase()}`, 'info');
            if (userExists) {
                setUserExists(userExists);

                let approvedState = await apiService.getUserStatus(wwid);
                let apiRes = await apiService.getUserApprovedRegionRole(wwid);
                if (approvedState.status === 'Accepted') {
                    localStorage.setItem('region', approvedState.regions);
                    localStorage.setItem('function', JSON.stringify(approvedState.profession));
                    setFuncLoaded(true);
                }
                else {
                    if (apiRes) {
                        localStorage.setItem('region', apiRes.region);
                        localStorage.setItem('function', JSON.stringify(apiRes.function));
                    }
                    else {
                        localStorage.setItem('region', approvedState.regions);
                        localStorage.setItem('function', JSON.stringify('Commercial'));
                    }
                    setFuncLoaded(true);
                }
                await getShortcutforHomePageByuserId();
                await getBookmarkShortcutforHomePageByuserId();
                /*Get the localStorage values to getAllFilters POST Call*/
                /* if(localStorage.getItem('contentpreference') == null){ */
                let res = await apiService.getUserPreferenceFromUserDetails(wwid);
                localStorage.setItem('contentpreference', JSON.stringify(res?.contentprefernce));
                /* localStorage.setItem('region',res.regions); */
                localStorage.setItem('userproducts', res.products);
                localStorage.setItem('doctypepref', res.docs);

                let reqBody = {
                    "function": localStorage.getItem('function').replace(/"/g, ''),
                    "doctypepref": localStorage.getItem('doctypepref'),
                    "userproducts": localStorage.getItem('userproducts'),
                    "region": localStorage.getItem('region'),
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, '')
                }
                let response = await service.getAllFilters(reqBody)
                if (response) {

                    let processedFilters = processFilters(response.data.body)
                    setAllFilters(processedFilters);
                    setFilters(processedFilters);
                    setIsLoaded(true);
                    setIsProcessing(false);

                }
                setRecentlyUsedFilters(JSON.parse(localStorage.getItem('recentlyUsedFilters')))
            } else {
                console.log('Access Denied');
                history.push('/');
            }
            localStorage.removeItem('selectedResults')
            localStorage.removeItem('ItemsPerPage')
            localStorage.removeItem('ActivePage')
            localStorage.removeItem('markedResultsUrl')
            sessionStorage.clear();
        } catch (error) {

        }

    }, []);
    useEffect(() => {
        const updateDimensions = () => {
            setCustomWidth(window.innerWidth);
            setCustomHeight(window.innerHeight)
        }
        // Add event listener
        window.addEventListener('resize', updateDimensions);
        // Cleanup function: remove event listener when component unmounts
        return () => {
            let service = new Services();
            window.removeEventListener('resize', updateDimensions);
            service.logService(`Gen Ai Home page successfully unmounted for ${userid.toLowerCase()}`, 'info')
        };
    }, []); // Empty dependency array ensures this effect runs only once on mount

    useEffect(() => {
        try {
            let username = JSON.parse(localStorage.getItem('userdisplayName'));
            if (username) {
                let userNameSplit = username.split(" ");
                if (userNameSplit.length > 1) {
                    let firstName = userNameSplit[0];
                    let lastName = userNameSplit[1];
                    setInitials(`${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`)
                } else {
                    setInitials(`${username[0].toUpperCase()}`)
                }
            }
        } catch (error) {
        }
    }, []);
    const getUpdatedFilters = async (filterSelected) => {
        filterSelected = filterSelected.filter(
            (x) => !x.startsWith("Recently Added_Updated")
        );
        let filterStr = generateArrayString(filterSelected);
        let query = "";
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
        setIsProcessing(true);
        var url = LocationOrigin + process.env.REACT_APP_IMS_API_PREFIX + "qp/runSearch";
        const _headers = {
            "Content-Type": "application/json"
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let config = {
            method: "POST",
            url: url,
            headers: _headers,
            data: {
                query: query,
                filters: filterStr,
                function: localStorage.getItem("function").replace(/"/g, ""),
                doctypepref: localStorage.getItem("doctypepref"),
                userproducts: localStorage.getItem("userproducts"),
                region: localStorage.getItem("region"),
                username: localStorage
                    .getItem("username")
                    .toLowerCase()
                    .replace(/"/g, ""),
                contentpreference: localStorage
                    .getItem("contentpreference")
                    .replace(/"/g, ""),
                from: 0,
                size: 1,
                sortBy: "",
                sortField: "",
                boolean: false,
                accessGroup: getFormattedAccessGroup(userAccessGroup),
                source: "searchID",
                excludeHighlight: true,

            },
        };
        axios(config)
            .then((response) => {
                let processedFilters = processFilters(response.data.body)
                setAllFilters(processedFilters);
                setFilters(processedFilters);
                setIsLoaded(true);
                setIsProcessing(false);

            })
            .catch(function (error) {

            })
            .finally(async () => {
                setIsProcessing(false);
            })
    }
    const getShortcutforHomePageByuserId = async () => {
        let service = new ApiServices();
        let wwid = JSON.parse(localStorage.getItem('wwid'));
        let _contentShortcutsInfo = [];
        await service.getShortcutforHomePageByuserId(wwid)
            .then((response) => {
                response.map(x => {
                    let _filterContentShortcutsInfo = ContentShortcutsInfo.find(z => z.uniqueKey == x.cs_key);
                    if (_filterContentShortcutsInfo) {
                        _contentShortcutsInfo.push(_filterContentShortcutsInfo);
                    }
                })
                setSavedShortcuts(_contentShortcutsInfo)
                // setSavedShortcuts(response)
            }).catch((error) => {
                setSavedShortcuts([])
                console.log(error);
            }).finally(() => {
            });
    }
    const getBookmarkShortcutforHomePageByuserId = async () => {
        let service = new ApiServices();
        let wwid = JSON.parse(localStorage.getItem('wwid'));
        await service.getBookmarkShortcutforHomePageByuserId(wwid)
            .then((response) => {
                setBookmarkShortcuts(response)
            }).catch((error) => {
                setBookmarkShortcuts([])
                console.log(error);
            }).finally(() => {
            });
    }
    const updateSCAddForHome = async () => {
        //setIsLoaded(false);
        await getShortcutforHomePageByuserId();
        setIsLoaded(true);
    }

    const updateBMAddForHome = async () => {
        //setIsLoaded(false);
        await getBookmarkShortcutforHomePageByuserId();
        setIsLoaded(true);
    }

    const handleChangeInSearch = (query, _dropdownValue, _fieldedValue) => {
        setSearchKeyword(query);
        let params = queryString.parse(location.search);
        //        let url = `/results?query=${query}&q=All%20Fields&filters=`
        // const newUrl = buildUrl(query, _dropdownValue, _fieldedValue, appliedFilters);
        let dateRange = getToDateAndFromDate(fromRecentlyAddedUpdated, toRecentlyAddedUpdated);
        const newUrl = recentlyAddedUpdatedbuildUrl(query, _dropdownValue, _fieldedValue, appliedFilters, false, dateRange);
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            "Conducted Search",
            "",
            newUrl,
            query,
            appliedFilters,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            ""
        );
        history.push({ pathname: '/results', search: newUrl, state: { selectedFilters: selectedFilters, allFilters: allFilters, appliedFilters: appliedFilters } });
        //     history.push(url)
    }
    const handleAIMode = (query) => {
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
        let _appliedCoreFilters = [], _selectedCoreFilters = [];
        let isFilterAccess = (!userAccessGroup.includes(LimitedUser) && userAccessGroup.includes(AllContent));
        if (isFilterAccess) {
            _appliedCoreFilters = Object.assign([], appliedFilters);
            _appliedCoreFilters = _appliedCoreFilters.filter((c) => !c.startsWith("Recently Added_Updated"));
            _selectedCoreFilters = Object.assign([], selectedFilters);
            _selectedCoreFilters = _selectedCoreFilters.filter((c) => !c.startsWith("Recently Added_Updated"));
        }
        setSearchKeyword(query)
        if (query && isFilterAccess) {
            if ((query && query.trim() != "") ||
                (_appliedCoreFilters && _appliedCoreFilters.length > 0)) {
                let filterStr = GenerateArrayStrings(_appliedCoreFilters)
                filterStr = encodeURIComponent(filterStr);
                window.open(`/genAIAnswering?query=${encodeURIComponent(query.trim())}&filters=${filterStr}`, '_blank')
            }
            // let data = {
            //     sessionID: uuidv4(),
            //     newQuestion: query,
            //     attachedFiles: [],
            //     threadID: uuidv4(),
            //     selectedFilters: [],
            //     renderfilters: [],
            //     isComprehensive: false,
            //     isGraphThread: false,
            //     selectedGraphType: '',
            //     isImageThread: false,
            //     appliedCoreFilters: _appliedCoreFilters,
            //     selectedCoreFilters: _selectedCoreFilters,
            // }
            // history.push({
            //     pathname: '/genAISearch',
            //     state: data // your data array of objects
            // })
        } else {
            let data = {
                newQuestion: query ? query : "",
            }
            if ((query && query.trim() != "") ||
                (_appliedCoreFilters && _appliedCoreFilters.length > 0)) {
                let filterStr = GenerateArrayStrings(_appliedCoreFilters)
                filterStr = encodeURIComponent(filterStr);
                window.open(`/genAIAnswering?query=${encodeURIComponent(query.trim())}&filters=${filterStr}`, '_blank')
            } else {
                window.open(`/genAIAnswering`, '_blank')
            }
            // history.push({
            //     pathname: '/genAIAnswering',
            //     state: data // your data array of objects
            // })
        }
    }
    const handleShowFilters = (_showFilters) => {
        setShowContentShortcuts(false);
        setShowFilters(_showFilters);
    }
    const handleShowContentShortcuts = (_showContentShortcuts) => {
        setShowFilters(false);
        setShowContentShortcuts(_showContentShortcuts);
    }
    const handleIsProcessing = (isLoaded) => {
        setIsLoaded(isLoaded)
    }
    const handleAllFilters = (allfilters, appliedfilters, selectedFilters) => {
        let selectedFacets = generateSelectParentArray(appliedfilters);
        setSelectedParentFilterArr(selectedFacets);
        setAllFilters(allfilters);
        setAppliedFilters(appliedfilters);
        setSelectedFilters(selectedFilters);
    }
    const handleOnChangeInfilter = (allfilters, appliedfilters, selectedFilters) => {

        if (selectedFilters && selectedFilters.length === 0
            && appliedfilters && appliedfilters.length > 0) {
            let childsWithParents = [];

            appliedfilters.forEach((element) => {
                const filterService = new FilterService();
                childsWithParents = [
                    ...childsWithParents,
                    ...filterService.getChildKeysOfFilter(filters, element),
                ];
            });
            childsWithParents = [...appliedfilters, ...childsWithParents];
            handleAllFilters(allfilters, appliedfilters, childsWithParents);
            getUpdatedFilters(appliedfilters)
        } else {
            handleAllFilters(allfilters, appliedfilters, selectedFilters);
            getUpdatedFilters(appliedfilters);
        }
        if (customWidth < 1000) {
            let params = queryString.parse(location.search);
            const newUrl = buildUrl(params.query, params.q, params.f1, appliedfilters);
            history.push({ pathname: '/results', search: newUrl, state: { selectedFilters: selectedFilters, allFilters: allfilters, appliedFilters: appliedfilters } });
        }

    }
    const handleRemoveAppliedFilter = (facet) => {
        try {
            let parentFacetName = facet.split("/")[0];
            let arr = selectedParentFilterArr;
            const index = arr.indexOf(parentFacetName);
            if (index > -1) {
                arr.splice(index, 1);
            }
            let _appliedFilters = appliedFilters.filter(
                (filter) => !filter.startsWith(facet)
            )
            let _selectedFilters = selectedFilters.filter(
                (filter) => filter && !filter.startsWith(facet)
            )
            setAppliedFilters(_appliedFilters);
            setSelectedParentFilterArr(selectedParentFilterArr);
            setFromRecentlyAddedUpdated(0);
            setToRecentlyAddedUpdated(6);
            setSelectedFilters(_selectedFilters);
            let dateRange = { min: 0, max: 6 };
            let RecentlyAddedUpdatedAppliedFilters =
                _appliedFilters.filter((c) =>
                    c.startsWith("Recently Added_Updated")
                );
            if (RecentlyAddedUpdatedAppliedFilters.length > 0) {
                const filterParts =
                    RecentlyAddedUpdatedAppliedFilters[0].split("/");
                const filterTop = filterParts[1];
                dateRange =
                    UtilityServices.getSelectedYearForRecentlyAddedUpdated(
                        filterTop
                    );
            }
            setFromRecentlyAddedUpdated(dateRange.min);
            setToRecentlyAddedUpdated(dateRange.max);

        } catch (error) {

        }
    };
    // const handleOnChangeInfilter = (
    //     filters,
    //     appliedfilters,
    //     selectedFilters,
    //     response,
    //     doc,
    //     query
    // ) => {
    //     try {
    //         let params = queryString.parse(location.search);
    //         //var filters = appliedfilters;
    //         filters = appliedfilters;
    //         let selectedFacets = generateSelectParentArray(appliedfilters);
    //         const newUrl = buildUrl(
    //             params.query,
    //             params.q,
    //             params.f1,
    //             filters);
    //         setSelectedFilters(selectedFilters);
    //         setAppliedFilters(appliedfilters);
    //         history.push({
    //             pathname: "/genAIRecommendedHome",
    //             search: newUrl,
    //             state: {
    //                 selectedFilters: selectedFilters,
    //                 allFilters: allFilters,
    //                 appliedFilters: appliedfilters,
    //             },
    //         });
    //     } catch (error) {
    //     }
    // };
    const generateArrayString = (array) => {
        let arrStr = ''
        array.map((item, index) => {
            if (index === array.length - 1) {
                arrStr += item
            }
            else {
                arrStr += item + ";"
            }
            return null
        })

        return arrStr
    }


    const gotoPageRecentlyAddedUpdated = (yearSelection) => {
        setFromRecentlyAddedUpdated(yearSelection.min);
        setToRecentlyAddedUpdated(yearSelection.max);

        let dateRange = getToDateAndFromDate(yearSelection.min, yearSelection.max);
        let params = queryString.parse(location.search);
        let _appliedFilters = appliedFilters.filter(x => !x.startsWith('Recently Added_Updated'));
        let displayYear = UtilityServices.getSelectedYearDisplay(yearSelection);

        if (displayYear && displayYear !== "All") {
            _appliedFilters.push(`Recently Added_Updated/${displayYear}`)
        }
        var filters = _appliedFilters;
        let selectedFacets = generateSelectParentArray(_appliedFilters);
        const newUrl = recentlyAddedUpdatedbuildUrl(searchKeyword, params.q, params.f1, filters, false, dateRange);
        setSelectedParentFilterArr(selectedFacets);
        setAllFilters(allFilters);
        setAppliedFilters(_appliedFilters)
        setShowFilters(false)
        if (customWidth < 1000) {
            history.push({
                pathname: '/results', search: newUrl, state: {
                    selectedFilters: selectedFacets,
                    allFilters: allFilters,
                    appliedFilters: _appliedFilters
                }
            });
        }
    }
    const handleClearFilters = () => {
        try {
            //console.log('Clear Filters from Breadcrumbs')
            setSelectedFilters([]);
            setAppliedFilters([]);
            // setFilters([])
            setSelectedParentFilterArr([]);
            //selectedParentFilterArr: [],
        } catch (error) {

        }
    };
    const generateSelectParentArray = (appliedfilters) => {
        let parentFacet = [];
        appliedfilters.forEach(filter => {
            const filterParts = filter.split('/')
            const filterTop = filterParts[0]
            parentFacet.push(filterTop)
        });
        return parentFacet;
    }
    const getToDateAndFromDate = (_fromRecentlyAddedUpdated, _toRecentlyAddedUpdated) => {

        let dateRange = { toDate: null, fromDate: null };

        if (_fromRecentlyAddedUpdated === 1) {
            dateRange.fromDate = moment()
                .subtract(365, "days")
                .startOf("date")
                .format("YYYY-MM-DD");
        } else if (_fromRecentlyAddedUpdated === 2) {
            dateRange.fromDate = moment()
                .subtract(180, "days")
                .startOf("date")
                .format("YYYY-MM-DD");
        } else if (_fromRecentlyAddedUpdated === 3) {
            dateRange.fromDate = moment()
                .subtract(30, "days")
                .startOf("date")
                .format("YYYY-MM-DD");
        } else if (_fromRecentlyAddedUpdated === 4) {
            dateRange.fromDate = moment()
                .subtract(7, "days")
                .startOf("date")
                .format("YYYY-MM-DD");
        } else if (_fromRecentlyAddedUpdated === 5) {
            dateRange.fromDate = moment()
                .subtract(1, "days")
                .startOf("date")
                .format("YYYY-MM-DD");
        }

        if (_toRecentlyAddedUpdated === 1) {
            dateRange.toDate = moment()
                .subtract(365, "days")
                .endOf("date")
                .format("YYYY-MM-DD");
        } else if (_toRecentlyAddedUpdated === 2) {
            dateRange.toDate = moment()
                .subtract(180, "days")
                .endOf("date")
                .format("YYYY-MM-DD");
        } else if (_toRecentlyAddedUpdated === 3) {
            dateRange.toDate = moment()
                .subtract(30, "days")
                .endOf("date")
                .format("YYYY-MM-DD");
        } else if (_toRecentlyAddedUpdated === 4) {
            dateRange.toDate = moment()
                .subtract(7, "days")
                .endOf("date")
                .format("YYYY-MM-DD");
        } else if (_toRecentlyAddedUpdated === 5) {
            dateRange.toDate = moment()
                .subtract(1, "days")
                .endOf("date")
                .format("YYYY-MM-DD");
        }

        return dateRange;
    }
    // const buildUrl = (searchKeyword, dropdownValue, fieldedVal, filters) => {
    //     let filterStr = GenerateArrayStrings(filters)
    //     filterStr = encodeURIComponent(filterStr);
    //     if (searchKeyword === undefined || dropdownValue === undefined) {
    //         return `?query=&q=All Fields&filters=${filterStr}`;
    //     }
    //     else if (dropdownValue === '' || dropdownValue === null) {
    //         return `?query=${searchKeyword}&q=All Fields&filters=${filterStr}`
    //     }
    //     else {
    //         return `?query=${searchKeyword}&q=${dropdownValue}&filters=${filterStr}&f1=${fieldedVal}&fval1=${searchKeyword}&fcount=1`;
    //     }

    // }

    const recentlyAddedUpdatedbuildUrl = (searchKeyword, dropdownValue, fieldedVal, filters, isClearSearch, dateRange) => {
        let filterStr = generateArrayString(filters)
        let url;
        if (!searchKeyword && !fieldedVal) {
            url = `?query=&q=All Fields&filters=${filterStr}`;
        }
        else if (!dropdownValue || (dropdownValue && dropdownValue === "All Fields")) {
            url = `?query=${encodeURIComponent(searchKeyword)}&q=All Fields&filters=${filterStr}`
        }
        else {
            url = `?query=${encodeURIComponent(searchKeyword)}&q=${dropdownValue}&filters=${filterStr}&f1=${fieldedVal}&fval1=${encodeURIComponent(searchKeyword)}&fcount=1`;
        }

        if ((dateRange && dateRange.fromDate) || (dateRange && dateRange.toDate)) {
            url = url + `&isDateRange=Yes&rangeField=modifiedDate`
            if (dateRange.fromDate) {
                url = url + `&fromRange=${dateRange.fromDate}`
            }
            if (dateRange.toDate) {
                url = url + `&toRange=${dateRange.toDate}`
            }
        }
        return url;
    }
    const buildUrl = (searchKeyword, dropdownValue, fieldedVal, filters) => {
        let filterStr = GenerateArrayStrings(filters)
        filterStr = encodeURIComponent(filterStr);
        if (!searchKeyword && !fieldedVal) {
            return `?query=&q=All Fields&filters=${filterStr}`;
        }
        else if (!dropdownValue || (dropdownValue && dropdownValue === "All Fields")) {
            return `?query=${encodeURIComponent(searchKeyword)}&q=All Fields&filters=${filterStr}`
        }
        else {
            return `?query=${encodeURIComponent(searchKeyword)}&q=${dropdownValue}&filters=${filterStr}&f1=${fieldedVal}&fval1=${searchKeyword}&fcount=1`;
        }

    }
    const handelAnDCardDetailModal = (isClicked) => setShowAnDCSModal(isClicked);
    const handelSRnCSCardDetailModal = (isClicked) => setShowSRnCSModal(isClicked);
    const handelEnTCardDetailModal = (isClicked) => setShowEnTCSModal(isClicked);
    const handelKMLCardDetailModal = (isClicked) => setShowKMLCSModal(isClicked);
    const handelKCLCardDetailModal = (isClicked) => setShowKCLCSModal(isClicked);
    const handelLDCardDetailModal = (isClicked) => setShowLDCSModal(isClicked);
    const handelSCDCardDetailModal = (isClicked) => setShowSCDCSModal(isClicked);
    const handelCRPCardDetailModal = (isClicked) => setShowCRPCSModal(isClicked);
    const handelTAnDCardDetailModal = (isClicked) => setShowTAnDCSModal(isClicked);
    const handelEPCardDetailModal = (isClicked) => setShowEPCSModal(isClicked);
    const handelMIRCardDetailModal = (isClicked) => setShowMIRCSModal(isClicked);
    const handelMCETCardDetailModal = (isClicked) => setShowMCECSModal(isClicked);
    const handelGMAFCardDetailModal = (isClicked) => setShowGMAFCSModal(isClicked);
    const handelcloseCSModal = () => {
        setShowAnDCSModal(false);
        setShowSRnCSModal(false);
        setShowEnTCSModal(false);
        setShowKMLCSModal(false);
        setShowKCLCSModal(false);
        setShowLDCSModal(false);
        setShowSCDCSModal(false);
        setShowCRPCSModal(false);
        setShowTAnDCSModal(false);
        setShowEPCSModal(false);
        setShowMIRCSModal(false);
        setShowMCECSModal(false);
        setShowGMAFCSModal(false);
    }
    const onScrollSavedShortcuts = (e) => {
        setSavedShortcutsScrollTimeStamp(e.timeStamp);
    }
    const handleDisclaimerClose = async () => {
        setShowDisclaimerPopup(false);
    }

    if (customWidth < 600) {
        return (
            <ErrorBoundary>
                {userExists ? <>
                    <NavigationMenu pathName={window.location.pathname} customWidth={customWidth} customHeight={customHeight} />
                    <div className="header-wrapper">
                        <HeaderSearch history={history} dropdownValue='All Fields' searchKeyword=''
                            appliedFilters={appliedFilters} handleChangeInSearch={handleChangeInSearch} customWidth={customWidth} customHeight={customHeight} />
                    </div>
                    <div className="recommended-contents-wrapper">
                        <ResponsiveFilterComponent pathName={window.location.pathname} customWidth={customWidth} customHeight={customHeight} allFilters={allFilters} filters={filters} appliedFilters={appliedFilters} handleAllfilters={handleAllFilters} handleOnChangeInfilter={handleOnChangeInfilter} selectedFilters={selectedFilters} selectedParentFilterArr={selectedParentFilterArr} querytext={searchKeyword} isProcessing={isProcessing} recentlyUsedFilters={recentlyUsedFilters}
                            handleIsProcessing={handleIsProcessing}
                            fromRecentlyAddedUpdated={fromRecentlyAddedUpdated} toRecentlyAddedUpdated={toRecentlyAddedUpdated} gotoPageRecentlyAddedUpdated={gotoPageRecentlyAddedUpdated} />
                        {funcLoaded &&
                            <>
                                {JSON.parse(localStorage.getItem('function')) !== "Commercial" &&
                                    <ContentShortcut showFilters={showFilters}
                                        showAnDCSModal={showAnDCSModal}
                                        showSRnCSModal={showSRnCSModal}
                                        showEnTCSModal={showEnTCSModal}
                                        showKMLCSModal={showKMLCSModal}
                                        showKCLCSModal={showKCLCSModal}
                                        showLDCSModal={showLDCSModal}
                                        showSCDCSModal={showSCDCSModal}
                                        showCRPCSModal={showCRPCSModal}
                                        showTAnDCSModal={showTAnDCSModal}
                                        showEPCSModal={showEPCSModal}
                                        showMIRCSModal={showMIRCSModal}
                                        showMCECSModal={showMCECSModal}
                                        showGMAFCSModal={showGMAFCSModal}
                                        handelAnDCardDetailModal={(e) => handelAnDCardDetailModal(e)}
                                        handelSRnCSCardDetailModal={(e) => handelSRnCSCardDetailModal(e)}
                                        handelEnTCardDetailModal={(e) => handelEnTCardDetailModal(e)}
                                        handelKMLCardDetailModal={(e) => handelKMLCardDetailModal(e)}
                                        handelKCLCardDetailModal={(e) => handelKCLCardDetailModal(e)}
                                        handelLDCardDetailModal={(e) => handelLDCardDetailModal(e)}
                                        handelSCDCardDetailModal={(e) => handelSCDCardDetailModal(e)}
                                        handelCRPCardDetailModal={(e) => handelCRPCardDetailModal(e)}
                                        handelTAnDCardDetailModal={(e) => handelTAnDCardDetailModal(e)}
                                        handelEPCardDetailModal={(e) => handelEPCardDetailModal(e)}
                                        handelMIRCardDetailModal={(e) => handelMIRCardDetailModal(e)}
                                        handelMCETCardDetailModal={(e) => handelMCETCardDetailModal(e)}
                                        handelGMAFCardDetailModal={(e) => handelGMAFCardDetailModal(e)}
                                        customWidth={customWidth} customHeight={customHeight}
                                    // showCSModal={showCSModal}
                                    /* handelCardDetailModal={(e)=>handelCardDetailModal(e)} */ />
                                }
                                {/* <WNFYSection customWidth={customWidth} customHeight={customHeight} />
                                <WOAVSection customWidth={customWidth} customHeight={customHeight} />
                                <RecentlyViewedSection customWidth={customWidth} customHeight={customHeight} />
                                <QueryHistorySection customWidth={customWidth} customHeight={customHeight} /> */}
                            </>
                        }
                    </div>
                    <div className="cs-modalOuter" style={{ display: (showAnDCSModal || showSRnCSModal || showEnTCSModal || showKMLCSModal || showKCLCSModal || showLDCSModal || showSCDCSModal || showCRPCSModal || showTAnDCSModal || showEPCSModal || showMIRCSModal || showMCECSModal || showGMAFCSModal) ? null : "none" }} onClick={handelcloseCSModal}></div>
                    <div style={{ margin: "0% 1%", marginTop: "auto" }}>
                        <Footer customWidth={customWidth} customHeight={customHeight} />
                    </div>
                </>
                    :
                    <div style={{ textAlign: "center", padding: "10%" }}>
                        <img src={imsLoader} alt="Loading Data" style={{ width: "20%" }} />
                    </div>
                }
            </ErrorBoundary>)
    }
    else if (customWidth >= 600 && customWidth < 1000) {
        return (<ErrorBoundary>
            {userExists ? <>
                <div className="genAIRecommendedInnerWrapper">
                    <GenAIHomeHeader initials={initials} title="Content Center-AI" customWidth={customWidth}
                        customHeight={customHeight} pathName={window.location.pathname} updateBMAddForHome={updateBMAddForHome} />
                    <div className="genAIRecommended-SearchAskQuestion-contentShortcuts-wrapper">
                        <SearchAskQuestionIndex
                            customWidth={customWidth}
                            customHeight={customHeight}
                            searchKeyword={searchKeyword}
                            showFilters={showFilters}
                            showContentShortcuts={showContentShortcuts}
                            handleChangeInSearch={handleChangeInSearch}
                            handleShowFilters={handleShowFilters}
                            handleShowContentShortcuts={handleShowContentShortcuts}
                            handleAIMode={handleAIMode}
                            dropdownValue='All Fields'


                            filters={filters}
                                    appliedFilters={appliedFilters}
                                    handleAllfilters={handleAllFilters}
                                    handleOnChangeInfilter={handleOnChangeInfilter}
                                    selectedFilters={selectedFilters}
                                    selectedParentFilterArr={selectedParentFilterArr}
                                    querytext={searchKeyword}
                                    isProcessing={isProcessing}
                                    handleIsProcessing={handleIsProcessing}
                                    customWidth={customWidth}
                                    recentlyUsedFilters={recentlyUsedFilters}
                                    fromRecentlyAddedUpdated={fromRecentlyAddedUpdated}
                                    toRecentlyAddedUpdated={toRecentlyAddedUpdated}
                                    gotoPageRecentlyAddedUpdated={gotoPageRecentlyAddedUpdated}
                                    isHomePageFilter={true}
                        />
                        <div className="genAIRecommended-main-filter-contentShortcuts-wrapper">
                            <div className="genAIRecommended-main-filter-contentShortcuts">
                               

                                {/* <Popover
                                    isOpen={showFilters}
                                    positions={['right', 'top']}
                                    align={'start'}
                                    reposition={false}
                                    scrollable
                                    containerStyle={{
                                        top: '0px',
                                    }}
                                    onClickOutside={(e) => {
                                        if (!(e && e.srcElement && e.srcElement.classList && (e.srcElement.classList.contains('popoverAvoidClickOutside') || e.srcElement.closest(".react-tiny-popover-container")))) {
                                            setShowFilters(false);
                                        }
                                    }} // This is the key!
                                    content={(positions, align) => (
                                        <div className={"genAIRecommended-filterMenuWrapper filterMenuWrapper filterMenuWrapperExpanded"} style={{ float: "left" }}>
                                            <div className="gen-ai-filter-menu-content">
                                                {isLoaded ?
                                                    <> <div className="gen-ai-filter-menu-content-header">
                                                        <button className='gen-ai-filter-menu-content-header-close popoverAvoidClickOutside' onClick={() => setShowFilters(false)}>
                                                            <img className='popoverAvoidClickOutside' src={popCancelBttn} width="22" height="22" alt="" />
                                                        </button>
                                                    </div>
                                                        <GenAISearchFilter allFilters={allFilters}
                                                            filters={filters}
                                                            appliedFilters={appliedFilters}
                                                            handleAllfilters={handleAllFilters}
                                                            handleOnChangeInfilter={handleOnChangeInfilter}
                                                            selectedFilters={selectedFilters}
                                                            selectedParentFilterArr={selectedParentFilterArr}
                                                            querytext={searchKeyword}
                                                            isProcessing={isProcessing}
                                                            handleIsProcessing={handleIsProcessing}
                                                            customWidth={customWidth}
                                                            recentlyUsedFilters={recentlyUsedFilters}
                                                            fromRecentlyAddedUpdated={fromRecentlyAddedUpdated}
                                                            toRecentlyAddedUpdated={toRecentlyAddedUpdated}
                                                            gotoPageRecentlyAddedUpdated={gotoPageRecentlyAddedUpdated}
                                                            isHomePageFilter={true} />
                                                    </>
                                                    :
                                                    <div style={{ textAlign: "center", padding: "10%" }}>
                                                        <img src={imsLoader} alt="Loading Filters" style={{ width: "20%" }} />
                                                    </div>}
                                            </div>
                                        </div>
                                    )}>
                                    <div />
                                </Popover> */}
                                <Popover
                                    isOpen={showContentShortcuts}
                                    positions={['bottom', 'right']}
                                    align={'start'}
                                    // reposition={false}
                                    scrollable
                                    containerStyle={{
                                        // left: "-10vw",
                                        top: '5px',
                                    }}
                                    onClickOutside={(e) => {
                                        if (!(e && e.srcElement && e.srcElement.classList &&
                                            (e.srcElement.classList.contains('popoverAvoidClickOutside') ||
                                                e.srcElement.classList.contains('popoverAvoidClickOutside-cs') ||
                                                e.srcElement.closest('.popoverAvoidClickOutside') ||
                                                e.srcElement.closest(".react-tiny-popover-container")))) {
                                            setShowContentShortcuts(false);
                                        }
                                    }} // This is the key!
                                    content={(positions, align) => (
                                        <div className={"genAIRecommended-content-shortcutWrapper filterMenuWrapper filterMenuWrapperExpanded"} >
                                            <div className="gen-ai-recommended-contents-wrapper">
                                                <div className="cs-row-header">
                                                    <button className='popoverAvoidClickOutside' onClick={e => setShowContentShortcuts(false)} style={{ visibility: "hidden" }}>
                                                        <img className='popoverAvoidClickOutside' src={popCancelBttn} width="22" height="22" alt="" />
                                                    </button>
                                                    <span>Content Shortcuts</span>
                                                    <button className='genAIRecommended-content-shortcut-close popoverAvoidClickOutside' onClick={e => setShowContentShortcuts(false)}>
                                                        <img className='popoverAvoidClickOutside' src={popCancelBttn} width="22" height="22" alt="" />
                                                    </button>
                                                </div>
                                                <div className="genAIRecommended-content-shortcut-wrapper">
                                                    {funcLoaded &&
                                                        <>
                                                            {JSON.parse(localStorage.getItem('function')) !== "Commercial" &&
                                                                <ContentShortcutGenAI
                                                                    customWidth={customWidth}
                                                                    customHeight={customHeight}
                                                                    updateSCAddForHome={updateSCAddForHome} />
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                            <div className="cs-modalOuter" style={{ display: (showAnDCSModal || showSRnCSModal || showEnTCSModal || showKMLCSModal || showKCLCSModal || showLDCSModal || showSCDCSModal || showCRPCSModal || showTAnDCSModal || showEPCSModal || showMIRCSModal) ? null : "none" }} onClick={(e) => { handelcloseCSModal(e) }}></div>
                                        </div>
                                    )}>
                                    <div />
                                </Popover>

                            </div>
                        </div>
                        {/* <div className="genAIRecommended-main-filter-contentShortcuts-wrapper">
                            <div className="genAIRecommended-main-filter-contentShortcuts">
                                {appliedFilters && appliedFilters.length > 0 && (
                                    <GenAIHomeFilterDisplay
                                        allFilters={allFilters}
                                        appliedFilters={appliedFilters}
                                        handleClearFilters={handleClearFilters}
                                        handleRemoveAppliedFilter={
                                            handleRemoveAppliedFilter
                                        }
                                        customWidth={customWidth} />
                                )}
                            </div>
                        </div> */}
                        <div className="cs-home-screen-wrapper">
                            {isLoaded ? <>
                                <HomeBookmarkShortcut bookmarkShortcuts={bookmarkShortcuts} updateBMAddForHome={updateBMAddForHome}
                                customWidth={customWidth}
                                        customHeight={customHeight} />
                                <div className="cs-hs-wrapper" onScroll={onScrollSavedShortcuts}>
                                    {(SavedShortcuts && SavedShortcuts.length > 0) && <HomeCSShortcut customWidth={customWidth}
                                        customHeight={customHeight} SavedShortcuts={SavedShortcuts} _isLoaded={isLoaded}
                                        SavedShortcutsScrollTimeStamp={savedShortcutsScrollTimeStamp}
                                        updateSCAddForHome={updateSCAddForHome}
                                    />}
                                </div>
                            </> :
                                <div className="cs-hs-list" role="list">
                                    <div style={{ textAlign: "center", }}>
                                        <img src={imsLoader} alt="Loading Data" style={{ width: "100px" }} />
                                    </div>
                                </div>}
                        </div>
                    </div>
                    {/* <div>
                        {isShowAIOverview && <div className="genAIRecommended-content-footer-content">
                            <p>iMedical Search GenAI Answers can make mistakes please verify critical information.<br /> You are reminded that no personal information or GxP data should be uploaded onto this platform, and you are required to comply with the. <a className="authoring-model-body-content-link" onClick={() => { setShowDisclaimerPopup(true) }}>GenAI Adherence Policy</a></p>
                        </div>}
                        <GenAIHomeFooter isShowAIOverview={isShowAIOverview} />
                    </div> */}
                    <GenAIHomeFooter isShowAIOverview={isShowAIOverview} />
                </div>
                {showDisclaimerPopup && <AuthoringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={handleDisclaimerClose} />}
            </> : <div style={{ textAlign: "center", padding: "10%" }}>
                <img src={imsLoader} alt="Loading Data" style={{ width: "20%" }} />
            </div>}
        </ErrorBoundary>)
    }
    else {
        return (<ErrorBoundary>
            {userExists ? <>
                <div className="genAIRecommendedInnerWrapper">
                    <GenAIHomeHeader initials={initials} title="Content Center-AI" customWidth={customWidth}
                        customHeight={customHeight} pathName={window.location.pathname} updateBMAddForHome={updateBMAddForHome} />
                    <div className="genAIRecommended-SearchAskQuestion-contentShortcuts-wrapper">
                        <SearchAskQuestionIndex
                            customWidth={customWidth}
                            customHeight={customHeight}
                            searchKeyword={searchKeyword}
                            showFilters={showFilters}
                            showContentShortcuts={showContentShortcuts}
                            handleChangeInSearch={handleChangeInSearch}
                            handleShowFilters={handleShowFilters}
                            handleShowContentShortcuts={handleShowContentShortcuts}
                            handleAIMode={handleAIMode}
                            dropdownValue='All Fields'
                        />
                        <div className="genAIRecommended-main-filter-contentShortcuts-wrapper">
                            <div className="genAIRecommended-main-filter-contentShortcuts">
                                <Popover
                                    isOpen={showFilters}
                                    positions={['right', 'top']}
                                    align={'start'}
                                    reposition={false}
                                    scrollable
                                    containerStyle={{
                                        top: '0px',
                                    }}
                                    onClickOutside={(e) => {
                                        if (!(e && e.srcElement && e.srcElement.classList && (e.srcElement.classList.contains('popoverAvoidClickOutside') || e.srcElement.closest(".react-tiny-popover-container")))) {
                                            setShowFilters(false);
                                        }
                                    }} // This is the key!
                                    content={(positions, align) => (
                                        <div className={"genAIRecommended-filterMenuWrapper filterMenuWrapper filterMenuWrapperExpanded"} style={{ float: "left" }}>
                                            <div className="gen-ai-filter-menu-content">
                                                {isLoaded ?
                                                    <> <div className="gen-ai-filter-menu-content-header">
                                                        <button className='gen-ai-filter-menu-content-header-close popoverAvoidClickOutside' onClick={() => setShowFilters(false)}>
                                                            <img className='popoverAvoidClickOutside' src={popCancelBttn} width="22" height="22" alt="" />
                                                        </button>
                                                    </div>
                                                        <GenAISearchFilter allFilters={allFilters}
                                                            filters={filters}
                                                            appliedFilters={appliedFilters}
                                                            handleAllfilters={handleAllFilters}
                                                            handleOnChangeInfilter={handleOnChangeInfilter}
                                                            selectedFilters={selectedFilters}
                                                            selectedParentFilterArr={selectedParentFilterArr}
                                                            querytext={searchKeyword}
                                                            isProcessing={isProcessing}
                                                            handleIsProcessing={handleIsProcessing}
                                                            customWidth={customWidth}
                                                            recentlyUsedFilters={recentlyUsedFilters}
                                                            fromRecentlyAddedUpdated={fromRecentlyAddedUpdated}
                                                            toRecentlyAddedUpdated={toRecentlyAddedUpdated}
                                                            gotoPageRecentlyAddedUpdated={gotoPageRecentlyAddedUpdated}
                                                            isHomePageFilter={true} />
                                                    </>
                                                    :
                                                    <div style={{ textAlign: "center", padding: "10%" }}>
                                                        <img src={imsLoader} alt="Loading Filters" style={{ width: "20%" }} />
                                                    </div>}
                                            </div>
                                        </div>
                                    )}>
                                    <div />
                                </Popover>
                                <Popover
                                    isOpen={showContentShortcuts}
                                    positions={['bottom', 'right']}
                                    align={'start'}
                                    // reposition={false}
                                    scrollable
                                    containerStyle={{
                                        left: "-10vw",
                                        top: '5px',
                                    }}
                                    onClickOutside={(e) => {
                                        if (!(e && e.srcElement && e.srcElement.classList &&
                                            (e.srcElement.classList.contains('popoverAvoidClickOutside') ||
                                                e.srcElement.classList.contains('popoverAvoidClickOutside-cs') ||
                                                e.srcElement.closest('.popoverAvoidClickOutside') ||
                                                e.srcElement.closest(".react-tiny-popover-container")))) {
                                            setShowContentShortcuts(false);
                                        }
                                    }} // This is the key!
                                    content={(positions, align) => (
                                        <div className={"genAIRecommended-content-shortcutWrapper filterMenuWrapper filterMenuWrapperExpanded"} >
                                            <div className="gen-ai-recommended-contents-wrapper">
                                                <div className="cs-row-header">
                                                    <button className='popoverAvoidClickOutside' onClick={e => setShowContentShortcuts(false)} style={{ visibility: "hidden" }}>
                                                        <img className='popoverAvoidClickOutside' src={popCancelBttn} width="22" height="22" alt="" />
                                                    </button>
                                                    <span>Content Shortcuts</span>
                                                    <button className='genAIRecommended-content-shortcut-close popoverAvoidClickOutside' onClick={e => setShowContentShortcuts(false)}>
                                                        <img className='popoverAvoidClickOutside' src={popCancelBttn} width="22" height="22" alt="" />
                                                    </button>
                                                </div>
                                                <div className="genAIRecommended-content-shortcut-wrapper">
                                                    {funcLoaded &&
                                                        <>
                                                            {JSON.parse(localStorage.getItem('function')) !== "Commercial" &&
                                                                <ContentShortcutGenAI
                                                                    customWidth={customWidth}
                                                                    customHeight={customHeight}
                                                                    updateSCAddForHome={updateSCAddForHome} />
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                            <div className="cs-modalOuter" style={{ display: (showAnDCSModal || showSRnCSModal || showEnTCSModal || showKMLCSModal || showKCLCSModal || showLDCSModal || showSCDCSModal || showCRPCSModal || showTAnDCSModal || showEPCSModal || showMIRCSModal) ? null : "none" }} onClick={(e) => { handelcloseCSModal(e) }}></div>
                                        </div>
                                    )}>
                                    <div />
                                </Popover>

                            </div>
                        </div>
                        {/* <div className="genAIRecommended-main-filter-contentShortcuts-wrapper">
                            <div className="genAIRecommended-main-filter-contentShortcuts">
                                {appliedFilters && appliedFilters.length > 0 && (
                                    <GenAIHomeFilterDisplay
                                        allFilters={allFilters}
                                        appliedFilters={appliedFilters}
                                        handleClearFilters={handleClearFilters}
                                        handleRemoveAppliedFilter={
                                            handleRemoveAppliedFilter
                                        }
                                        customWidth={customWidth} />
                                )}
                            </div>
                        </div> */}
                        <div className="cs-home-screen-wrapper">
                            {isLoaded ? <>
                                <HomeBookmarkShortcut bookmarkShortcuts={bookmarkShortcuts} updateBMAddForHome={updateBMAddForHome}
                                customWidth={customWidth}
                                        customHeight={customHeight} />
                                <div className="cs-hs-wrapper" onScroll={onScrollSavedShortcuts}>
                                    {(SavedShortcuts && SavedShortcuts.length > 0) && <HomeCSShortcut customWidth={customWidth}
                                        customHeight={customHeight} SavedShortcuts={SavedShortcuts} _isLoaded={isLoaded}
                                        SavedShortcutsScrollTimeStamp={savedShortcutsScrollTimeStamp}
                                        updateSCAddForHome={updateSCAddForHome}
                                    />}
                                </div>
                            </> :
                                <div className="cs-hs-list" role="list">
                                    <div style={{ textAlign: "center", }}>
                                        <img src={imsLoader} alt="Loading Data" style={{ width: "100px" }} />
                                    </div>
                                </div>}
                        </div>
                    </div>
                    {/* <div>
                        {isShowAIOverview && <div className="genAIRecommended-content-footer-content">
                            <p>iMedical Search GenAI Answers can make mistakes please verify critical information.<br /> You are reminded that no personal information or GxP data should be uploaded onto this platform, and you are required to comply with the. <a className="authoring-model-body-content-link" onClick={() => { setShowDisclaimerPopup(true) }}>GenAI Adherence Policy</a></p>
                        </div>}
                        <GenAIHomeFooter isShowAIOverview={isShowAIOverview} />
                    </div> */}
                    <GenAIHomeFooter isShowAIOverview={isShowAIOverview} />
                </div>
                {showDisclaimerPopup && <AuthoringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={handleDisclaimerClose} />}
            </> : <div style={{ textAlign: "center", padding: "10%" }}>
                <img src={imsLoader} alt="Loading Data" style={{ width: "20%" }} />
            </div>}
        </ErrorBoundary>)
    }
}